export default (astStr: string) => {
	return `
    class Context {
        constructor(data) {
            this.data = data || {};
        }
        push(newData) {
            let copyData = {};
            for (let k in this.data) {
                copyData[k] = this.data[k];
            }
            for (let k in newData) {a
                copyData[k] = newData[k];
            }
            return new Context(copyData);
        }
        pop() {
            return this.data;
        }
    }
    
    class Render {
        constructor(ast) {
            this.ast = ast;
        }
    
        async show() {
            const type = config.widgetFamily;
            if (type) {
                Script.setWidget(this.render(ast));
                return;
            }
            const opts = ['small', 'medium', 'large'];
            const funcs = ['presentSmall', 'presentMedium', 'presentLarge'];
            const index = await generateAlert('预览大小', opts);
            await this.render(ast)[funcs[index]]();
        }
    
        render(ast) {
            const hdlFuncSet = {
                stack(me, parent, ctx) {
                    const stack = parent.addStack();
                    applyAttrs(stack, me.attrs, ctx);
                    me.children.forEach(child => {
                        process(child, stack, ctx);
                    });
                },
                image(me, parent, ctx) {
                    const imageData = Data.fromBase64String(me.children[0]);
                    const image = Image.fromData(imageData);
                    applyAttrs(parent.addImage(image), me.attrs, ctx);
                },
                text(me, parent, ctx) {
                    let match,
                        array = [],
                        str = me.children[0];
                    while ((match = str.match(/\\{\\{.*?\\}\\}/))) {
                        array.push(str.substring(0, match.index));
                        array.push(echo(match[0], ctx));
                        str = str.substring(match.index + match[0].length);
                    }
                    array.push(str);
                    applyAttrs(parent.addText(array.join('')), me.attrs, ctx);
                },
                date(me, parent, ctx) {
                    applyAttrs(parent.addDate(new Date(echo(me.attrs.date, ctx))), me.attrs, ctx);
                },
                spacer(me, parent, ctx) {
                    parent.addSpacer(echo(me.children[0] || null, ctx));
                },
            };
            const that = this;
            const ctx = new Context({});
            const root = ast;
            const widget = new ListWidget();
            applyAttrs(widget, root.attrs, ctx);
            root.children.forEach(child => process(child, widget, ctx));
            return widget;
    
            function process(me, parent, ctx) {
                const func = hdlFuncSet[me.tagName];
                func && func(me, parent, ctx);
            }
    
            function echo(exp, ctx) {
                if (typeof exp !== 'string') return exp; // not string
                const match = exp.match(/\\{\\{\\s*([^\\s]+)\\s*\\}\\}/);
                if (!match) return exp; // not exp
                exp = match[1];
                const data = ctx.pop();
                let str = '{';
                if (Object.keys(data).length !== 0) {
                    for (let k in data) {
                        str += k + ',';
                    }
                    str = str.substring(0, str.length - 1) + '}';
                } else {
                    str = '{}';
                }
                return new Function(
                    'data',
                    \`const \${str}={...data};return \${exp};\`
                )(data);
            }
    
            function applyAttrs(ele, attrs, ctx) {
                for (let key in attrs) {
                    if (!key) return;
                    that.getAttrFunc(key)?.apply(null, [ele].concat(echo(attrs[key], ctx)));
                }
            }
        }
    
        getAttrFunc(key) {
            console.log("======" + key + "======")
            return {
                // property:
                // widget、stack
                backgroundColor(obj, color) {
                    obj.backgroundColor = new Color(color);
                },
                backgroundGradient(obj, gradVal) {
                    if (gradVal.colors === "" || gradVal.locations === "") return;
                    const lg = new LinearGradient()
                    lg.colors = gradVal.colors.split(',').map(c => new Color(c))
                    lg.locations = gradVal.locations.split(',').map(l => Number(l))
                    lg.startPoint = new Point(0, 0)
                    lg.endPoint = new Point(Math.sin(gradVal.angle), Math.cos(gradVal.angle))
                    obj.backgroundGradient = lg;
                },
                bgImageDate(obj, base64ImageDate) {
                    const imageDate = Data.fromBase64String(base64ImageDate)
                    const image = Image.fromData(imageDate)
                    obj.backgroundImage = image;
                },
                spacing(obj, number) {
                    obj.spacing = number;
                },
                // stack
                size(obj, size) {
                    obj.size = new Size(size.width, size.height);
                },
                // widget
                refreshAfterDate(obj, date) {
                    obj.refreshAfterDate = new Date(date);
                },
                // common
                url(obj, url) {
                    obj.url = url;
                },
                // text、date
                font(obj, font) {
                    obj.font = new Font(font.type, font.size);
                },
                lineLimit(obj, number) {
                    obj.lineLimit = number;
                },
                minimumScaleFactor(obj, number) {
                    obj.minimumScaleFactor = number;
                },
                shadowColor(obj, color) {
                    obj.shadowColor = new Color(color);
                },
                shadowOffset(obj, offset) {
                    obj.shadowOffset = new Point(offset.x, offset.y);
                },
                shadowRadius(obj, radius) {
                    obj.shadowRadius = radius;
                },
                textColor(obj, color) {
                    obj.textColor = new Color(color);
                },
                textOpacity(obj, opacity) {
                    obj.textOpacity = opacity;
                },
                // stack、image
                borderColor(obj, color) {
                    obj.borderColor = new Color(color);
                },
                borderWidth(obj, width) {
                    obj.borderWidth = width;
                },
                cornerRadius(obj, radius) {
                    obj.cornerRadius = radius;
                },
                // image
                containerRelativeShape(obj, bool) {
                    obj.containerRelativeShape = bool;
                },
                imageOpacity(obj, opacity) {
                    obj.imageOpacity = opacity;
                },
                imageSize(obj, size) {
                    if (size.width > 0 && size.height > 0)
                        obj.imageSize = new Size(size.width, size.height);
                },
                resizable(obj, bool) {
                    obj.resizable = bool;
                },
                tintColor(obj, color) {
                    obj.tintColor = new Color(color);
                },
                // methods:
                // stack、widget
                padding(obj, padding) {
                    obj.setPadding(padding.top, padding.left, padding.bottom, padding.right);
                },
                // stack
                alignContent(obj, type) {
                    const typeMap = {
                        'flex-start': 'topAlignContent',
                        'flex-end': 'bottomAlignContent',
                        'center': 'centerAlignContent',
                    }
                    obj[typeMap[type]]()
                },
                layout(obj, type) {
                    const typeMap = {
                        width: 'layoutHorizontally',
                        height: 'layoutVertically'
                    }
                    obj[typeMap[type]]()
                },
                // text、date
                alignText(obj, type) {
                    const typeMap = {
                        'flex-start': 'leftAlignText',
                        'flex-end': 'rightAlignText',
                        'center': 'centerAlignText',
                    }
                    obj[typeMap[type]]()
                },
                // Image
                alignImage(obj, type) {
                    const typeMap = {
                        'flex-start': 'leftAlignImage',
                        'flex-end': 'rightAlignImage',
                        'center': 'centerAlignImage',
                    }
                    obj[typeMap[type]]()
                },
                contentMode(obj, type) {
                    const typeMap = {
                        fit: 'applyFittingContentMode',
                        fill: 'applyFillingContentMode',
                    }
                    obj[typeMap[type]]()
                },
                // date
                style(obj, type) {
                    const typeMap = {
                        date: 'applyDateStyle',
                        time: 'applyTimeStyle',
                        timer: 'applyTimerStyle',
                        relative: 'applyRelativeStyle',
                        offset: 'applyOffsetStyle',
                    }
                    obj[typeMap[type]]()
                }
            }[key];
        }
    }
    
    async function generateAlert(message, options) {
        let alert = new Alert();
        alert.message = message;
        for (const option of options) {
            alert.addAction(option);
        }
        return await alert.presentAlert();
    }
    
    const ast = JSON.parse('${astStr}')
    const render = new Render(ast)
    await render.show()
    Script.complete()    
    `;
};
